import { clsx } from 'clsx';

import { ItemOfOrderTotals } from './components';

import { useTotalsDetailModule } from './hooks';
import makeClasses from './TotalsDetailModule.style';

import type { OrderId } from 'shared/domain';

export function TotalsDetailModule({ orderId }: Props) {
  const {
    isRender,
    isOpen,
    hasDetails,
    isFSDeliveryMethod,
    totals,
    handleToggle,
  } = useTotalsDetailModule({ orderId });

  const _classes = makeClasses();

  if (!isRender) return null;
  return (
    <section aria-label='totals-detail-module' className={_classes.module}>
      <aside
        aria-label='details'
        data-is-open={isOpen}
        className={_classes.details}
      >
        {totals.detail.item.subtotal && (
          <>
            <ItemOfOrderTotals
              className={_classes.item}
              item={totals.detail.item.subtotal}
            />
            <div className={_classes.divider} />
          </>
        )}

        {totals.detail.item.discountPartnerStore && (
          <ItemOfOrderTotals
            className={_classes.item}
            item={totals.detail.item.discountPartnerStore}
          />
        )}
        {totals.detail.item.totalStore && (
          <ItemOfOrderTotals
            className={clsx(_classes.item, _classes.totalStore)}
            item={totals.detail.item.totalStore}
          />
        )}
        {totals.detail.item.discountRappi && (
          <>
            {isFSDeliveryMethod && <div className={_classes.divider} />}
            <ItemOfOrderTotals
              className={_classes.item}
              item={totals.detail.item.discountRappi}
            />
          </>
        )}
        {totals.detail.item.suggestedTotal && (
          <ItemOfOrderTotals
            className={clsx(_classes.item, _classes.totalStore)}
            item={totals.detail.item.suggestedTotal}
          />
        )}

        {totals.detail.extraItems.map(itemExtra => (
          <ItemOfOrderTotals
            key={itemExtra.id}
            item={itemExtra}
            className={_classes.item}
          />
        ))}

        {totals.detail.item.totalDiscount && (
          <>
            {!isFSDeliveryMethod && <div className={_classes.divider} />}
            <ItemOfOrderTotals
              className={_classes.item}
              item={totals.detail.item.totalDiscount}
            />
          </>
        )}
        <div className={_classes.divider} />
      </aside>
      <main onClick={handleToggle}>
        <ItemOfOrderTotals
          item={totals.main}
          showDetail={hasDetails}
          isDetailShown={isOpen}
          className={clsx(_classes.item, _classes.totalMain)}
        />
      </main>
    </section>
  );
}

interface Props {
  orderId: OrderId;
}
